import { useEffect, useRef } from "react";

type UseWebOtpOptions = {
  onOtp: (code: string) => void;
};

const USE_FAKE_OTP = false; // turn off before production


export function useWebOtp({ onOtp }: UseWebOtpOptions) {

  const onOtpRef = useRef(onOtp);

  useEffect(() => {
    onOtpRef.current = onOtp;
  }, [onOtp]);
  
  useEffect(() => {

    if (USE_FAKE_OTP) {
      const timeoutId = setTimeout(() => {
        onOtpRef.current("123456");
      }, 800);
  
      return () => clearTimeout(timeoutId);
    }
    
    if (!("OTPCredential" in window)) return;
    if (!("credentials" in navigator)) return;

    const ac = new AbortController();

    (navigator.credentials.get({
      otp: { transport: ["sms"] },
      signal: ac.signal,
    } as any) as Promise<any>)
      .then((otp) => {       
        const raw = otp?.code;
        if (typeof raw === "string" && raw) {
          const code = raw.replace(/\D/g, "").slice(0, 6);
          if (code) onOtpRef.current(code);
        }
      })
      .catch(() => {});

    return () => ac.abort();
  }, []);
}







